module.exports = __webpack_public_path__ + "img/service6EN.91933d57.svg";